import { makeStyles, fade } from "@material-ui/core/styles";
import { getSafeOrDefault } from "../../../util/object-util";

const playListItemStyles = makeStyles((theme) => ({
	fragmentList: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		color: theme.palette.gameMode.primary
	},
	detailList: {
		width: "100%",
		margin: "4px 0 0 0",
		padding: "0 0 0 20px",
		listStyle: "disc",
		"& li": {
			fontSize: "0.85em"
		}
	},
	listItem: {
		color: theme.palette.gameMode.primary,
		padding: "10px 0"
	},
	// Marks every play of the drive currently being replayed on the field.
	replaying: {
		backgroundColor: fade(theme.palette.menu.item.active.backgroundColor, 0.12)
	},
	divider: {
		borderBottom: `1px solid ${theme.palette.border.primary}`
	},
	itemContent: {
		width: "100%"
	},
	driveMarkers: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 6,
		marginTop: 6
	},
	driveMarker: {
		minHeight: 23,
		lineHeight: 1.5,
		minWidth: 90,
		textAlign: "center",
		border: "1px solid #4c5768",
		borderRadius: 2,
		padding: "0 8px",
		fontWeight: 700
	},
	driveStart: {
		backgroundColor: "#1f8a4c",
		color: "#fff"
	},
	driveEnd: {
		backgroundColor: "#b3402f",
		color: "#fff"
	},
	turnover: {
		backgroundColor: "#c77d11",
		color: "#fff"
	},
	itemHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		height: 30
	},
	square: {
		minWidth: 45,
		maxHeight: 23,
		lineHeight: 1.5,
		textAlign: "center",
		border: "1px solid #4c5768",
		borderRadius: 2,
		marginRight: 10
	},
	playNumber: {
		minWidth: 25,
		maxHeight: 23,
		lineHeight: 1.5,
		textAlign: "center",
		border: "1px solid #4c5768",
		borderRadius: 2,
		marginRight: 10,
		backgroundColor: ({ team }) =>
			getSafeOrDefault(() => team.color, theme.palette.gameMode.secondary),
		color: ({ team }) =>
			getSafeOrDefault(() => team.contrastColor, theme.palette.gameMode.primary)
	},
	time: {
		color: theme.palette.gameMode.primary
	},
	update: {
		backgroundColor: theme.palette.gameMode.secondary,
		color: theme.palette.gameMode.primary,
		"& svg": {
			verticalAlign: "middle"
		}
	},
	title: {
		textAlign: "left",
		width: "100%"
	},
	icons: {
		display: "flex",
		flexDirection: "center",
		alignItems: "center"
	}
}));

export default playListItemStyles;
